module.exports = __webpack_public_path__ + "static/media/clients-02.b7065d2b.svg";